import { Injectable } 			from '@angular/core';
import { Http, Headers, 
		 Response, 
		 URLSearchParams } 		  from '@angular/http';
import { Observable } 			from 'rxjs/Rx'
import { Router }           from '@angular/router';
import { StorageService}    from './storage.service';
import { environment } from '../../environments/environment';
@Injectable()
export class UserService {
  private loggedIn = false;
  private baseUrl: string = '';

  constructor(private http : Http, public router: Router, private storage: StorageService){
    this.baseUrl = environment.baseUrl;
    this.loggedIn = this.storage.getObject('user') ? true : false;
  }

  private getToken() {
    let user = this.storage.getObject('user');
    return user["api_token"];
  }

  private getHeaders() {
    let username : string = 'test';
    let p : string = 'test';
    var headers = new Headers();
    headers.append('Access-Control-Allow-Origin','*');
    headers.append("Authorization", "Basic " + btoa(username + ":" + p));
    headers.append('Content-Type', 'application/x-www-form-urlencoded');
    let userAgent =  window.navigator.userAgent;
    headers.append('client-web',userAgent);
    return headers;
  }

  login(email: string, password: string) {
    let params: URLSearchParams = new URLSearchParams();
    params.set('email', email);
    params.set('password', password);
    return this.http.post(`${this.baseUrl}login`, params, { headers: this.getHeaders() })
            .map((response: Response) => response.json())
            .map((response) => {
		        if (response.status == "success") {
		          this.loggedIn = true;
		        }

		        return response;
		    }).catch((error:any) => Observable.throw(error.json().error || 'Server error'));
  }

  logout() {
    let params: URLSearchParams = new URLSearchParams();
    params.set('api_token', this.getToken());
    return this.http.post(`${this.baseUrl}logout`, params, { headers: this.getHeaders() })
            .map((response: Response) => response.json())
            .catch((error:any) => Observable.throw(error.json().error || 'Server error'));
  }

  clearUser() {
    this.storage.removeAll();
    this.loggedIn = false;
  }

  isLoggedIn() {
    return this.loggedIn;
  }

  resetPassword(token:string, email:string, password:string, confirm_password:string) {
    let params: URLSearchParams = new URLSearchParams();
    params.set('email', email);
    params.set('password', password);
    params.set('token', token);
    params.set('password_confirmation', confirm_password);
    return this.http.post(`${this.baseUrl}password/reset`, params, { headers: this.getHeaders() })
            .map((response: Response) => response.json())
            .catch((error:any) => Observable.throw(error.json().error || 'Server error'));
  }

  teamLogin(email: string, password: string) {
    let params: URLSearchParams = new URLSearchParams();
    params.set('slug', email);
    params.set('password', password);
    return this.http.post(`${this.baseUrl}team-login`, params, { headers: this.getHeaders() })
            .map((response: Response) => response.json())
            .catch((error:any) => Observable.throw(error.json()));
  }
  
}


// WEBPACK FOOTER //
// ./src/app/_services/user.service.ts